import React, { useEffect, useRef, useState, useContext } from 'react'
import { AuthContext } from '../../context/Auth/AuthContext';


export const digitosFirma = 6

let currentOtpIndex = 0

export function Otp(props) {

    const { updateToken } = useContext(AuthContext);

    const [otp, setOtp] = useState(new Array(digitosFirma).fill(""));
    const [activeOtpIndex, setActiveOtpIndex] = useState(0)

    const inputRef = useRef(null)

    const handleOnChange = ({ target }) => {
        const { value } = target
        const newOtp = [...otp]
        newOtp[currentOtpIndex] = value.substring(value.length - 1)

        if (!value) setActiveOtpIndex(currentOtpIndex - 1)
        else setActiveOtpIndex(currentOtpIndex + 1);

        setOtp(newOtp)
        updateToken(newOtp.join(''))
        let setOptInput = props?.setOptInput;
        if(setOptInput) setOptInput(newOtp.join(''))
    }

    const handleOnKeyDown = ({ key }, index) => {
        currentOtpIndex = index
        if (key === 'Backspace') setActiveOtpIndex(index - 1)
    }

    useEffect(() => {
        inputRef.current?.focus()
    }, [activeOtpIndex])

    return (
        otp.map((_, index) => {
            return (
                <React.Fragment key={index}>
                    <input
                        value={otp[index]}
                        ref={index === activeOtpIndex ? inputRef : null}
                        type="number"
                        name={props.name}
                        id={props.id}
                        className="text-purple spin-button-none transition mx-0.4 lg:mx-1 text-lg py-1 w-10 text-center border-2 border-tdark border-opacity-20 rounded-md focus:border-purple focus:ring-0"
                        onChange={handleOnChange}
                        onKeyDown={(e) => handleOnKeyDown(e, index)}
                    />
                    {index === otp.length - 1 ? null : (
                        <span className='w-2 py-0.5 text-purple text-opacity-40'>-</span>
                    )}

                </React.Fragment>
            )
        })
    )
}